import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {NotificationBaseApiDto, QuoteCommentNotificationDataApiDto} from "../../../api/model/rest";
import QuoteCommentNotificationData from "./QuoteCommentNotificationData";

/**
 * Quote comment notification class.
 */
export default class QuoteCommentNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if sms is marked as read.
	 * @param {string} type in this case always 'QUOTE_COMMENT_CREATED'.
	 * @param {QuoteCommentNotificationData} data quote comment notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: QuoteCommentNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): QuoteCommentNotification {
		return new QuoteCommentNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			QuoteCommentNotificationData.fromJson(json.data as QuoteCommentNotificationDataApiDto));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new QuoteCommentNotification(id, dateTime, read, type, data);
	}
}